// PDF Generation using browser print (no html2pdf.js dependency needed)

// Primary PDF generation using browser print dialog
export const generatePDF = async (invoiceData) => {
  try {
    const element = document.getElementById('invoice-preview');
    
    if (!element) {
      throw new Error('Invoice preview element not found');
    }

    // Clean invoice number for filename
    const invoiceNumber = invoiceData.invoiceDetails.number || 'draft';
    const cleanNumber = invoiceNumber.replace(/[^a-z0-9]/gi, '-').toLowerCase();

    // Create optimized print window
    const printWindow = window.open('', '_blank', 'width=800,height=600');
    
    const invoiceHTML = `<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Invoice ${invoiceData.invoiceDetails.number}</title>
  <script src="https://cdn.tailwindcss.com"></script>
  <link href="https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap" rel="stylesheet">
  <style>
    @media print { 
      body { 
        margin: 0; 
        padding: 20px; 
        font-family: 'Inter', sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
      } 
      .no-print { display: none !important; }
      * { 
        -webkit-print-color-adjust: exact !important; 
        color-adjust: exact !important; 
        print-color-adjust: exact !important;
      }
      .shadow-lg, .shadow-md, .shadow-sm { box-shadow: none !important; }
      .border { border: 1px solid #e5e7eb !important; }
    }
    @page { 
      margin: 0.5in;
      size: A4;
    }
    body { 
      font-family: 'Inter', sans-serif;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      line-height: 1.6;
    }
    .page-break-before { page-break-before: always; }
    .page-break-after { page-break-after: always; }
    .no-break { page-break-inside: avoid; }
  </style>
</head>
<body class="bg-white">
  ${element.innerHTML}
  <script>
    window.onload = function() {
      // Give time for fonts and styles to load
      setTimeout(function() {
        window.print();
        // Close window after printing
        setTimeout(function() { 
          window.close(); 
        }, 1000);
      }, 1500);
    }
  </script>
</body>
</html>`;
    
    printWindow.document.write(invoiceHTML);
    printWindow.document.close();
    
    return { 
      success: true, 
      filename: `invoice-${cleanNumber}.pdf`,
      method: 'print'
    };
  } catch (error) {
    console.error('Error generating PDF with print method:', error);
    throw error;
  }
};

// Fallback PDF generation using browser print dialog
export const generatePDFPrint = async (invoiceData) => {
  try {
    const element = document.getElementById('invoice-preview');
    if (!element) {
      throw new Error('Invoice preview element not found');
    }

    // Create optimized print window
    const printWindow = window.open('', '_blank', 'width=800,height=600');
    
    const invoiceHTML = `<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Invoice ${invoiceData.invoiceDetails.number}</title>
  <script src="https://cdn.tailwindcss.com"></script>
  <link href="https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap" rel="stylesheet">
  <style>
    @media print { 
      body { 
        margin: 0; 
        padding: 20px; 
        font-family: 'Inter', sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
      } 
      .no-print { display: none !important; }
      * { 
        -webkit-print-color-adjust: exact !important; 
        color-adjust: exact !important; 
        print-color-adjust: exact !important;
      }
      .shadow-lg, .shadow-md, .shadow-sm { box-shadow: none !important; }
      .border { border: 1px solid #e5e7eb !important; }
    }
    @page { 
      margin: 0.5in;
      size: A4;
    }
    body { 
      font-family: 'Inter', sans-serif;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      line-height: 1.6;
    }
    .page-break-before { page-break-before: always; }
    .page-break-after { page-break-after: always; }
    .no-break { page-break-inside: avoid; }
  </style>
</head>
<body class="bg-white">
  ${element.innerHTML}
  <script>
    window.onload = function() {
      setTimeout(function() {
        window.print();
        setTimeout(function() { 
          window.close(); 
        }, 1000);
      }, 1500);
    }
  </script>
</body>
</html>`;
    
    printWindow.document.write(invoiceHTML);
    printWindow.document.close();
    
    return { 
      success: true, 
      method: 'print',
      message: 'Print dialog opened. Use "Save as PDF" option in print dialog.'
    };
  } catch (error) {
    console.error('Error generating PDF via print:', error);
    return { success: false, error: error.message, method: 'print' };
  }
};

// Smart PDF generation - uses browser print method
export const smartGeneratePDF = async (invoiceData) => {
  try {
    console.log('Generating PDF using browser print method...');
    return await generatePDF(invoiceData);
  } catch (error) {
    console.warn('Primary method failed, trying fallback:', error);
    console.log('Using print dialog fallback...');
    return await generatePDFPrint(invoiceData);
  }
};

// Export default smart generator
export default smartGeneratePDF;